import * as React from 'react';
import { InputAdornmentButton } from '@cian/ui-kit';
import { useContext } from '../../../utils/useContext';
import { GeoInputAddonSection } from '../../../components/GeoInputAddonSection';

export function GeoSwitcherButtonsContainer() {
  const { onGeoPopupOpen } = useContext();

  return (
    <GeoInputAddonSection>
      <InputAdornmentButton type="button" onClick={onGeoPopupOpen}>
        Регион
      </InputAdornmentButton>
      <AdditionalGeoPopupButtonContainer />
    </GeoInputAddonSection>
  );
}

function AdditionalGeoPopupButtonContainer() {
  const {
    hasUnderground,
    hasDistricts,
    hasHighways,
    onUndergroundPopupOpen,
    onDistrictPopupOpen,
    onHighwaysPopupOpen,
  } = useContext();

  switch (true) {
    case hasUnderground:
      return (
        <InputAdornmentButton type="button" onClick={onUndergroundPopupOpen}>
          Метро
        </InputAdornmentButton>
      );
    case hasDistricts:
      return (
        <InputAdornmentButton type="button" onClick={onDistrictPopupOpen}>
          Район
        </InputAdornmentButton>
      );
    case hasHighways:
      return (
        <InputAdornmentButton type="button" onClick={onHighwaysPopupOpen}>
          Шоссе
        </InputAdornmentButton>
      );
    default:
      return null;
  }
}
